import { useState } from 'react';
import {
  ActionItemsByClientIdDocument,
  AiBadge,
  NextActionFormButton,
  Portal,
  UserAvatar,
  useSaveActionItemMutation
} from '../../../shared';
import { ButtonBase, ButtonProps, Checkbox, Stack, Typography, Link as MuiLink } from '@mui/material';
import * as React from 'react';
import moment from 'moment';
import { covertDateToSeverFormat } from '@coverright/utils';
import _ from 'lodash';
import { ActionItemOutput } from '@coverright/data-access/types/enrollment';

type Props = {
  item: ActionItemOutput,
  slots?: {
    userAvatar?: React.JSX.Element
  }
}

const Card = (props: ButtonProps & Props) => {
  const {item, onClick, slots, ...rest} = props
  const [checked, setChecked] = useState(item.done);
  const [disableRipple, setDisableRipple] = useState(false)
  const [save] = useSaveActionItemMutation({
    refetchQueries: [{
      query: ActionItemsByClientIdDocument,
      variables: { clientId: item.clientId }
    }]
  })

  const onCompletedClick = (checked: boolean) => {
    setChecked(checked);
    save({
      variables: {
        input: {
          ..._.pick(item, ['id', 'clientId', 'title', 'assigneeAgentId']),
          dueDate: covertDateToSeverFormat(item.dueDate),
          done: checked,
        }
      }
    })
  }

  const bgcolor = checked ? '#f7f7f7' : moment(item.dueDate).isBefore(moment(), 'day') ? '#fff2f2' : '#f2fffa';

  return <ButtonBase onClick={(e: any) => !disableRipple && onClick && onClick(e)}
                     sx={{alignItems: 'normal'}}
                     disableRipple={disableRipple} >
    <Portal sx={{bgcolor, transition: 'all .3s', width: 1, p: '0 12px 4px 0'}} direction={'row'} alignItems={'flex-start'}>
      <Checkbox size={'small'} sx={{m: 0}} checked={checked}
                onMouseEnter={() => setDisableRipple(true)}
                onMouseLeave={() => setDisableRipple(false)}
                onChange={e => {
                  e.stopPropagation();
                  onCompletedClick(e.currentTarget.checked)
                }} />
      <Stack gap={1} alignItems={'stretch'} flex={1}>
        <Stack direction={'row'} alignItems={'center'} gap={1} mt={1}>
          <Typography variant={'body2'} fontWeight={500} align={'left'} sx={{textDecoration: checked ? 'line-through' : 'none'}}>{item.title}</Typography>
          {item.aiGenerated === true && <AiBadge />}
        </Stack>

        <Stack gap={2} direction={'row'} alignItems={'center'}>
          <Typography variant={'caption'} fontSize={11} align={'left'} flex={1}>
            Due date:
            <Typography fontWeight={500} variant={'caption'} ml={1}>
              {item.dueDate ? moment(item.dueDate).format('L') : 'Not set'}
            </Typography>
          </Typography>

          {/*<Stack gap={.7} direction={'row'} alignItems={'center'} flex={1}>
            <UserCircle size={24} color="#1c434f" />

            <Typography variant={'caption'}
                        align={'left'}
                        onMouseEnter={() => setDisableRipple(true)}
                        onMouseLeave={() => setDisableRipple(false)}
                        onClick={e => {
                          e.stopPropagation();
                          navigate(`/${getRoute('client')}/${item.clientId}`)
                        }}
                        sx={{textDecoration: 'underline'}}
                        fontWeight={500}>
              {item.clientName}
            </Typography>
          </Stack>*/}

          {slots?.userAvatar || (
            <UserAvatar name={item.assigneeAgentName || ''}
                        email={item.assigneeAgentName || ''} size={24}
                        fontSize={11} />
          )}
        </Stack>
      </Stack>
    </Portal>

  </ButtonBase>
}


export const NextActionCard = ({item, slots}: Props) => {
  return <NextActionFormButton component={props => <Card item={item} slots={slots} {...props} />}
                               initialValues={{
                                 ...item,
                               }} />
}
